import { BigInt } from '@polkadot/x-bigint';
/**
 * @name _0n
 * @summary BigInt constant for 0.
 */
export const _0n = /*#__PURE__*/ BigInt(0);
/**
 * @name _1n
 * @summary BigInt constant for 1.
 */
export const _1n = /*#__PURE__*/ BigInt(1);
/**
 * @name _2n
 * @summary BigInt constant for 2.
 */
export const _2n = /*#__PURE__*/ BigInt(2);
/**
 * @name _3n
 * @summary BigInt constant for 3.
 */
export const _3n = /*#__PURE__*/ BigInt(3);
/**
 * @name _4n
 * @summary BigInt constant for 4.
 */
export const _4n = /*#__PURE__*/ BigInt(4);
/**
 * @name _5n
 * @summary BigInt constant for 5.
 */
export const _5n = /*#__PURE__*/ BigInt(5);
/**
 * @name _6n
 * @summary BigInt constant for 6.
 */
export const _6n = /*#__PURE__*/ BigInt(6);
/**
 * @name _7n
 * @summary BigInt constant for 7.
 */
export const _7n = /*#__PURE__*/ BigInt(7);
/**
 * @name _8n
 * @summary BigInt constant for 8.
 */
export const _8n = /*#__PURE__*/ BigInt(8);
/**
 * @name _9n
 * @summary BigInt constant for 9.
 */
export const _9n = /*#__PURE__*/ BigInt(9);
/**
 * @name _10n
 * @summary BigInt constant for 10.
 */
export const _10n = /*#__PURE__*/ BigInt(10);
/**
 * @name _100n
 * @summary BigInt constant for 100.
 */
export const _100n = /*#__PURE__*/ BigInt(100);
/**
 * @name _1000n
 * @summary BigInt constant for 1000.
 */
export const _1000n = /*#__PURE__*/ BigInt(1_000);
/**
 * @name _1Mn
 * @summary BigInt constant for 1,000,000 (million).
 */
export const _1Mn = /*#__PURE__*/ BigInt(1_000_000);
/**
* @name _1Bn
* @summary BigInt constant for 1,000,000,000 (billion).
*/
export const _1Bn = /*#__PURE__*/ BigInt(1_000_000_000);
/**
* @name _1Qn
* @summary BigInt constant for 1,000,000,000,000,000,000 (quitillion).
*/
export const _1Qn = _1Bn * _1Bn;
/**
* @name _2pow53n
* @summary BigInt constant for MAX_SAFE_INTEGER
*/
export const _2pow53n = /*#__PURE__*/ BigInt(Number.MAX_SAFE_INTEGER);
/**
 * @name _sqrt2pow53n
 * @summary BigInt constant for Math.sqrt(MAX_SAFE_INTEGER)
 */
export const _sqrt2pow53n = /*#__PURE__*/ BigInt(94906265);
